import { jsx } from 'panel';
import { getFestiveMode } from 'common/util/festive-mode';
import { SvgIconEl } from '../svg-icon';
import { SpinnerColor, SpinnerSize } from './types';
export function template() {
  const festiveMode = getFestiveMode();
  const showFestiveModeSpinner = this.attr("allow-festive") && !!festiveMode;
  return jsx("div", {
    class: Object.assign(Object.assign({}, showFestiveModeSpinner ? {
      'festive-mode-spinner': true,
      [festiveMode]: true
    } : {
      'mp-spinner': true,
      'mp-spinner-white': this.attr("color") === SpinnerColor.White
    }), {
      'large-spinner': this.attr("size") === SpinnerSize.Large
    })
  }, !showFestiveModeSpinner ? jsx(SvgIconEl, {
    attrs: {
      icon: "spinner"
    }
  }) : null);
}